import { millisecondsInHour as n } from "./index334.mjs";
import d from "./index259.mjs";
import f from "./index212.mjs";
import { getRoundingMethod as m } from "./index330.mjs";
function c(e, o, r) {
  f(2, arguments);
  var i = d(e, o) / n;
  return m(r?.roundingMethod)(i);
}
export {
  c as default
};
//# sourceMappingURL=index256.mjs.map
